import API from './index';

export const getNotifications = (params = {}) =>
  API.get(`/notifications`, { params });

export const setUserDevice = (token, platform, lang = localStorage?.locale) =>
  API.post(`/user/notification/device`, { token, platform, lang });

export const deleteUserDevice = (token, platform) =>
  API.post(
    `/user/notification/device/delete`,
    { token, platform },
    { silentUnauthorized: true }
  );

export const trackNewsletter = (data) =>
  API.post(`/user/newsletter/track`, data);
